// @flow
import * as React from "react";

import classNames from "classnames";

type Props = {
  message: string,
  className?: string,
};

function DangerAlert({ message, className }: Props): React.Node {
  return (
    <div className={classNames("alert alert-danger", className)} role="alert">
      {message}
    </div>
  );
}

export default DangerAlert;
